// source: pbtypes/vehicle/skills/actions/stop_for_photo_inspect/stop_for_photo_inspect.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_scan_planner_scan_waypoint_pb = require('../../../../../pbtypes/gen/scan_planner/scan_waypoint_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_scan_waypoint_pb);
var pbtypes_gen_uuid_util_uuid_pb = require('../../../../../pbtypes/gen/uuid_util/uuid_pb.js');
goog.object.extend(proto, pbtypes_gen_uuid_util_uuid_pb);
var pbtypes_gen_scan_planner_scan_photo_pb = require('../../../../../pbtypes/gen/scan_planner/scan_photo_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_scan_photo_pb);
var pbtypes_vehicle_skills_waypoints_pb = require('../../../../../pbtypes/vehicle/skills/waypoints_pb.js');
goog.object.extend(proto, pbtypes_vehicle_skills_waypoints_pb);
var pbtypes_vehicle_skills_actions_take_photo_take_photo_pb = require('../../../../../pbtypes/vehicle/skills/actions/take_photo/take_photo_pb.js');
goog.object.extend(proto, pbtypes_vehicle_skills_actions_take_photo_take_photo_pb);
var pbtypes_vehicle_skills_actions_trajectory_inspect_trajectory_inspect_pb = require('../../../../../pbtypes/vehicle/skills/actions/trajectory_inspect/trajectory_inspect_pb.js');
goog.object.extend(proto, pbtypes_vehicle_skills_actions_trajectory_inspect_trajectory_inspect_pb);
goog.exportSymbol('proto.skills.MotionSettings', null, global);
goog.exportSymbol('proto.skills.PhotoWaypointAction', null, global);
goog.exportSymbol('proto.skills.PhotoWaypointAction.ArgsCase', null, global);
goog.exportSymbol('proto.skills.StopForPhotoInspectActionArgs', null, global);
goog.exportSymbol('proto.skills.StopForPhotoInspectActionStateData', null, global);
goog.exportSymbol('proto.skills.StopForPhotoInspectResultData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.PhotoWaypointAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.skills.PhotoWaypointAction.oneofGroups_);
};
goog.inherits(proto.skills.PhotoWaypointAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.PhotoWaypointAction.displayName = 'proto.skills.PhotoWaypointAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.MotionSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.MotionSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.MotionSettings.displayName = 'proto.skills.MotionSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.StopForPhotoInspectActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skills.StopForPhotoInspectActionArgs.repeatedFields_, null);
};
goog.inherits(proto.skills.StopForPhotoInspectActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.StopForPhotoInspectActionArgs.displayName = 'proto.skills.StopForPhotoInspectActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.StopForPhotoInspectResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skills.StopForPhotoInspectResultData.repeatedFields_, null);
};
goog.inherits(proto.skills.StopForPhotoInspectResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.StopForPhotoInspectResultData.displayName = 'proto.skills.StopForPhotoInspectResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.StopForPhotoInspectActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.StopForPhotoInspectActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.StopForPhotoInspectActionStateData.displayName = 'proto.skills.StopForPhotoInspectActionStateData';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.skills.PhotoWaypointAction.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.skills.PhotoWaypointAction.ArgsCase = {
  ARGS_NOT_SET: 0,
  TAKE_PHOTO: 1
};

/**
 * @return {proto.skills.PhotoWaypointAction.ArgsCase}
 */
proto.skills.PhotoWaypointAction.prototype.getArgsCase = function() {
  return /** @type {proto.skills.PhotoWaypointAction.ArgsCase} */(jspb.Message.computeOneofCase(this, proto.skills.PhotoWaypointAction.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.PhotoWaypointAction.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.PhotoWaypointAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.PhotoWaypointAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.PhotoWaypointAction.toObject = function(includeInstance, msg) {
  var f, obj = {
takePhoto: (f = msg.getTakePhoto()) && pbtypes_vehicle_skills_actions_take_photo_take_photo_pb.TakePhotoActionArgs.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.PhotoWaypointAction}
 */
proto.skills.PhotoWaypointAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.PhotoWaypointAction;
  return proto.skills.PhotoWaypointAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.PhotoWaypointAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.PhotoWaypointAction}
 */
proto.skills.PhotoWaypointAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_vehicle_skills_actions_take_photo_take_photo_pb.TakePhotoActionArgs;
      reader.readMessage(value,pbtypes_vehicle_skills_actions_take_photo_take_photo_pb.TakePhotoActionArgs.deserializeBinaryFromReader);
      msg.setTakePhoto(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.PhotoWaypointAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.PhotoWaypointAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.PhotoWaypointAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.PhotoWaypointAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTakePhoto();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_vehicle_skills_actions_take_photo_take_photo_pb.TakePhotoActionArgs.serializeBinaryToWriter
    );
  }
};


/**
 * optional TakePhotoActionArgs take_photo = 1;
 * @return {?proto.skills.TakePhotoActionArgs}
 */
proto.skills.PhotoWaypointAction.prototype.getTakePhoto = function() {
  return /** @type{?proto.skills.TakePhotoActionArgs} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_skills_actions_take_photo_take_photo_pb.TakePhotoActionArgs, 1));
};


/**
 * @param {?proto.skills.TakePhotoActionArgs|undefined} value
 * @return {!proto.skills.PhotoWaypointAction} returns this
*/
proto.skills.PhotoWaypointAction.prototype.setTakePhoto = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.skills.PhotoWaypointAction.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.PhotoWaypointAction} returns this
 */
proto.skills.PhotoWaypointAction.prototype.clearTakePhoto = function() {
  return this.setTakePhoto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.PhotoWaypointAction.prototype.hasTakePhoto = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.MotionSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.MotionSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.MotionSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.MotionSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
globalVelocityLimit: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.MotionSettings}
 */
proto.skills.MotionSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.MotionSettings;
  return proto.skills.MotionSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.MotionSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.MotionSettings}
 */
proto.skills.MotionSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGlobalVelocityLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.MotionSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.MotionSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.MotionSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.MotionSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGlobalVelocityLimit();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
};


/**
 * optional float global_velocity_limit = 1;
 * @return {number}
 */
proto.skills.MotionSettings.prototype.getGlobalVelocityLimit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.MotionSettings} returns this
 */
proto.skills.MotionSettings.prototype.setGlobalVelocityLimit = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skills.StopForPhotoInspectActionArgs.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.StopForPhotoInspectActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.StopForPhotoInspectActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.StopForPhotoInspectActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
scanWaypointsList: jspb.Message.toObjectList(msg.getScanWaypointsList(),
    pbtypes_gen_scan_planner_scan_waypoint_pb.ScanWaypoint.toObject, includeInstance),
frame: jspb.Message.getFieldWithDefault(msg, 2, 0),
photoWaypointAction: (f = msg.getPhotoWaypointAction()) && proto.skills.PhotoWaypointAction.toObject(includeInstance, f),
motionSettings: (f = msg.getMotionSettings()) && proto.skills.MotionSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.StopForPhotoInspectActionArgs}
 */
proto.skills.StopForPhotoInspectActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.StopForPhotoInspectActionArgs;
  return proto.skills.StopForPhotoInspectActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.StopForPhotoInspectActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.StopForPhotoInspectActionArgs}
 */
proto.skills.StopForPhotoInspectActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_scan_planner_scan_waypoint_pb.ScanWaypoint;
      reader.readMessage(value,pbtypes_gen_scan_planner_scan_waypoint_pb.ScanWaypoint.deserializeBinaryFromReader);
      msg.addScanWaypoints(value);
      break;
    case 2:
      var value = /** @type {!proto.skills.FrameType.Enum} */ (reader.readEnum());
      msg.setFrame(value);
      break;
    case 3:
      var value = new proto.skills.PhotoWaypointAction;
      reader.readMessage(value,proto.skills.PhotoWaypointAction.deserializeBinaryFromReader);
      msg.setPhotoWaypointAction(value);
      break;
    case 4:
      var value = new proto.skills.MotionSettings;
      reader.readMessage(value,proto.skills.MotionSettings.deserializeBinaryFromReader);
      msg.setMotionSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.StopForPhotoInspectActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.StopForPhotoInspectActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.StopForPhotoInspectActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScanWaypointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_scan_planner_scan_waypoint_pb.ScanWaypoint.serializeBinaryToWriter
    );
  }
  f = message.getFrame();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPhotoWaypointAction();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.skills.PhotoWaypointAction.serializeBinaryToWriter
    );
  }
  f = message.getMotionSettings();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.skills.MotionSettings.serializeBinaryToWriter
    );
  }
};


/**
 * repeated scan_planner.ScanWaypoint scan_waypoints = 1;
 * @return {!Array<!proto.scan_planner.ScanWaypoint>}
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.getScanWaypointsList = function() {
  return /** @type{!Array<!proto.scan_planner.ScanWaypoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_scan_planner_scan_waypoint_pb.ScanWaypoint, 1));
};


/**
 * @param {!Array<!proto.scan_planner.ScanWaypoint>} value
 * @return {!proto.skills.StopForPhotoInspectActionArgs} returns this
*/
proto.skills.StopForPhotoInspectActionArgs.prototype.setScanWaypointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.scan_planner.ScanWaypoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scan_planner.ScanWaypoint}
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.addScanWaypoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.scan_planner.ScanWaypoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skills.StopForPhotoInspectActionArgs} returns this
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.clearScanWaypointsList = function() {
  return this.setScanWaypointsList([]);
};


/**
 * optional FrameType.Enum frame = 2;
 * @return {!proto.skills.FrameType.Enum}
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.getFrame = function() {
  return /** @type {!proto.skills.FrameType.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.skills.FrameType.Enum} value
 * @return {!proto.skills.StopForPhotoInspectActionArgs} returns this
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.setFrame = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional PhotoWaypointAction photo_waypoint_action = 3;
 * @return {?proto.skills.PhotoWaypointAction}
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.getPhotoWaypointAction = function() {
  return /** @type{?proto.skills.PhotoWaypointAction} */ (
    jspb.Message.getWrapperField(this, proto.skills.PhotoWaypointAction, 3));
};


/**
 * @param {?proto.skills.PhotoWaypointAction|undefined} value
 * @return {!proto.skills.StopForPhotoInspectActionArgs} returns this
*/
proto.skills.StopForPhotoInspectActionArgs.prototype.setPhotoWaypointAction = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.StopForPhotoInspectActionArgs} returns this
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.clearPhotoWaypointAction = function() {
  return this.setPhotoWaypointAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.hasPhotoWaypointAction = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MotionSettings motion_settings = 4;
 * @return {?proto.skills.MotionSettings}
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.getMotionSettings = function() {
  return /** @type{?proto.skills.MotionSettings} */ (
    jspb.Message.getWrapperField(this, proto.skills.MotionSettings, 4));
};


/**
 * @param {?proto.skills.MotionSettings|undefined} value
 * @return {!proto.skills.StopForPhotoInspectActionArgs} returns this
*/
proto.skills.StopForPhotoInspectActionArgs.prototype.setMotionSettings = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.StopForPhotoInspectActionArgs} returns this
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.clearMotionSettings = function() {
  return this.setMotionSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.StopForPhotoInspectActionArgs.prototype.hasMotionSettings = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skills.StopForPhotoInspectResultData.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.StopForPhotoInspectResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.StopForPhotoInspectResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.StopForPhotoInspectResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.StopForPhotoInspectResultData.toObject = function(includeInstance, msg) {
  var f, obj = {
completedWaypointUuidsList: jspb.Message.toObjectList(msg.getCompletedWaypointUuidsList(),
    pbtypes_gen_uuid_util_uuid_pb.Uuid.toObject, includeInstance),
photosList: jspb.Message.toObjectList(msg.getPhotosList(),
    pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto.toObject, includeInstance),
failureReason: jspb.Message.getFieldWithDefault(msg, 3, 0),
inspectionTimeS: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.StopForPhotoInspectResultData}
 */
proto.skills.StopForPhotoInspectResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.StopForPhotoInspectResultData;
  return proto.skills.StopForPhotoInspectResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.StopForPhotoInspectResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.StopForPhotoInspectResultData}
 */
proto.skills.StopForPhotoInspectResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_uuid_util_uuid_pb.Uuid;
      reader.readMessage(value,pbtypes_gen_uuid_util_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.addCompletedWaypointUuids(value);
      break;
    case 2:
      var value = new pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto;
      reader.readMessage(value,pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto.deserializeBinaryFromReader);
      msg.addPhotos(value);
      break;
    case 3:
      var value = /** @type {!proto.skills.InspectFailureReason} */ (reader.readEnum());
      msg.setFailureReason(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInspectionTimeS(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.StopForPhotoInspectResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.StopForPhotoInspectResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.StopForPhotoInspectResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.StopForPhotoInspectResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompletedWaypointUuidsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_uuid_util_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
  f = message.getPhotosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto.serializeBinaryToWriter
    );
  }
  f = message.getFailureReason();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getInspectionTimeS();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * repeated uuid_util.Uuid completed_waypoint_uuids = 1;
 * @return {!Array<!proto.uuid_util.Uuid>}
 */
proto.skills.StopForPhotoInspectResultData.prototype.getCompletedWaypointUuidsList = function() {
  return /** @type{!Array<!proto.uuid_util.Uuid>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_uuid_util_uuid_pb.Uuid, 1));
};


/**
 * @param {!Array<!proto.uuid_util.Uuid>} value
 * @return {!proto.skills.StopForPhotoInspectResultData} returns this
*/
proto.skills.StopForPhotoInspectResultData.prototype.setCompletedWaypointUuidsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.uuid_util.Uuid=} opt_value
 * @param {number=} opt_index
 * @return {!proto.uuid_util.Uuid}
 */
proto.skills.StopForPhotoInspectResultData.prototype.addCompletedWaypointUuids = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.uuid_util.Uuid, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skills.StopForPhotoInspectResultData} returns this
 */
proto.skills.StopForPhotoInspectResultData.prototype.clearCompletedWaypointUuidsList = function() {
  return this.setCompletedWaypointUuidsList([]);
};


/**
 * repeated scan_planner.ScanPhoto photos = 2;
 * @return {!Array<!proto.scan_planner.ScanPhoto>}
 */
proto.skills.StopForPhotoInspectResultData.prototype.getPhotosList = function() {
  return /** @type{!Array<!proto.scan_planner.ScanPhoto>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto, 2));
};


/**
 * @param {!Array<!proto.scan_planner.ScanPhoto>} value
 * @return {!proto.skills.StopForPhotoInspectResultData} returns this
*/
proto.skills.StopForPhotoInspectResultData.prototype.setPhotosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.scan_planner.ScanPhoto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scan_planner.ScanPhoto}
 */
proto.skills.StopForPhotoInspectResultData.prototype.addPhotos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.scan_planner.ScanPhoto, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skills.StopForPhotoInspectResultData} returns this
 */
proto.skills.StopForPhotoInspectResultData.prototype.clearPhotosList = function() {
  return this.setPhotosList([]);
};


/**
 * optional InspectFailureReason failure_reason = 3;
 * @return {!proto.skills.InspectFailureReason}
 */
proto.skills.StopForPhotoInspectResultData.prototype.getFailureReason = function() {
  return /** @type {!proto.skills.InspectFailureReason} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.skills.InspectFailureReason} value
 * @return {!proto.skills.StopForPhotoInspectResultData} returns this
 */
proto.skills.StopForPhotoInspectResultData.prototype.setFailureReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 inspection_time_s = 6;
 * @return {number}
 */
proto.skills.StopForPhotoInspectResultData.prototype.getInspectionTimeS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StopForPhotoInspectResultData} returns this
 */
proto.skills.StopForPhotoInspectResultData.prototype.setInspectionTimeS = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.StopForPhotoInspectActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.StopForPhotoInspectActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.StopForPhotoInspectActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.StopForPhotoInspectActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {
lastCompletedWaypointIdx: jspb.Message.getFieldWithDefault(msg, 1, 0),
estimatedTimeToCompletionS: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
numPhotoWaypointsCaptured: jspb.Message.getFieldWithDefault(msg, 3, 0),
numPhotoWaypointsFailedOrSkipped: jspb.Message.getFieldWithDefault(msg, 4, 0),
numConsecutiveStuckPhotoWaypoints: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.StopForPhotoInspectActionStateData}
 */
proto.skills.StopForPhotoInspectActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.StopForPhotoInspectActionStateData;
  return proto.skills.StopForPhotoInspectActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.StopForPhotoInspectActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.StopForPhotoInspectActionStateData}
 */
proto.skills.StopForPhotoInspectActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLastCompletedWaypointIdx(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setEstimatedTimeToCompletionS(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumPhotoWaypointsCaptured(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumPhotoWaypointsFailedOrSkipped(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumConsecutiveStuckPhotoWaypoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.StopForPhotoInspectActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.StopForPhotoInspectActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.StopForPhotoInspectActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.StopForPhotoInspectActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLastCompletedWaypointIdx();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getEstimatedTimeToCompletionS();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getNumPhotoWaypointsCaptured();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getNumPhotoWaypointsFailedOrSkipped();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getNumConsecutiveStuckPhotoWaypoints();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional int32 last_completed_waypoint_idx = 1;
 * @return {number}
 */
proto.skills.StopForPhotoInspectActionStateData.prototype.getLastCompletedWaypointIdx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StopForPhotoInspectActionStateData} returns this
 */
proto.skills.StopForPhotoInspectActionStateData.prototype.setLastCompletedWaypointIdx = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional float estimated_time_to_completion_s = 2;
 * @return {number}
 */
proto.skills.StopForPhotoInspectActionStateData.prototype.getEstimatedTimeToCompletionS = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StopForPhotoInspectActionStateData} returns this
 */
proto.skills.StopForPhotoInspectActionStateData.prototype.setEstimatedTimeToCompletionS = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional uint32 num_photo_waypoints_captured = 3;
 * @return {number}
 */
proto.skills.StopForPhotoInspectActionStateData.prototype.getNumPhotoWaypointsCaptured = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StopForPhotoInspectActionStateData} returns this
 */
proto.skills.StopForPhotoInspectActionStateData.prototype.setNumPhotoWaypointsCaptured = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 num_photo_waypoints_failed_or_skipped = 4;
 * @return {number}
 */
proto.skills.StopForPhotoInspectActionStateData.prototype.getNumPhotoWaypointsFailedOrSkipped = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StopForPhotoInspectActionStateData} returns this
 */
proto.skills.StopForPhotoInspectActionStateData.prototype.setNumPhotoWaypointsFailedOrSkipped = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 num_consecutive_stuck_photo_waypoints = 5;
 * @return {number}
 */
proto.skills.StopForPhotoInspectActionStateData.prototype.getNumConsecutiveStuckPhotoWaypoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.StopForPhotoInspectActionStateData} returns this
 */
proto.skills.StopForPhotoInspectActionStateData.prototype.setNumConsecutiveStuckPhotoWaypoints = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


goog.object.extend(exports, proto.skills);
